<template>
		<v-row justify="space-around">
			<v-col cols="auto">
				<v-dialog
						transition="dialog-top-transition"
						max-width="600"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							color="#ffffff"
							rounded
							class="primary-page-color"
							v-on="on"
							@click="showGallery"
						><v-icon>mdi-image</v-icon>{{ $t('videoContainer.gallery') }}</v-btn>
					</template>
					<template v-slot:default="dialog">
						<v-card>
							<v-card-text>
								<v-row class="d-flex align-center justify-center py-4 primary-page-color-dark">
									<h2>{{ $t('videoContainer.gallery') }}</h2>
								</v-row>
								<v-row class="d-flex align-center justify-center">
									<image-gallery v-if="imagesEnabled"/>
									<p v-else>{{ $t('videoContainer.imagesNotAvailable') }}</p>
								</v-row>
							</v-card-text>
							<v-card-actions class="justify-end">
								<v-btn
										text
										class="primary-page-color-dark"
										@click="dialog.value = false"
								>{{ $t('general.close')}}</v-btn>
							</v-card-actions>
						</v-card>
					</template>
				</v-dialog>
			</v-col>
		</v-row>
</template>

<script>
	import ImageGallery from "./ImageGallery";
	export default {
		name: "GalleryOverlay",
		props: {
			imagesEnabled: Boolean
		},
		components: {ImageGallery},
		methods: {
			showGallery() {
				const vm = this;

				vm.$ga.event({
					eventCategory: 'buttonPress',
					eventAction: 'openGallery'
				});
			}
		}
	}
</script>

<style scoped>
	.gallery-overlay-container {
		position: absolute;
		background-color: rgba(255,255,255,0.5);
		width: 100%;
	}

	.primary-page-color {
		color: rgba(81,77,247,1) !important;
		caret-color: rgba(81,77,247,1) !important;
	}

	.primary-page-color-dark {
		color: rgb(57, 54, 168)  !important;
		caret-color: rgb(57, 54, 168)  !important;
	}
</style>
